module.exports = __webpack_public_path__ + "img/bleed-tube.9ab167fb.svg";